document.addEventListener("DOMContentLoaded", () => {
  // ===== MOBILE MENU TOGGLE =====
  const menuButton = document.getElementById("mobile-menu-button");
  const mobileMenu = document.getElementById("mobile-menu");

  if (menuButton && mobileMenu) {
    menuButton.addEventListener("click", () => {
      mobileMenu.classList.toggle("hidden");
    });
  }

  // ===== CATEGORY SWIPER =====
  if (typeof Swiper !== "undefined") {
    new Swiper(".category-swiper", {
      slidesPerView: 1,
      spaceBetween: 16,
      loop: true,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      breakpoints: {
        640: { slidesPerView: 2, spaceBetween: 16 },
        1024: { slidesPerView: 3, spaceBetween: 24 },
      },
    });

    // ===== BEST SELLERS SWIPER =====
    new Swiper(".best-sellers-swiper", {
      slidesPerView: 1,
      spaceBetween: 20,
      loop: true,
      breakpoints: {
        768: { slidesPerView: 2 },
        1024: { slidesPerView: 3 },
      },
      // Navigation arrows
      navigation: {
        nextEl: ".next-slide",
        prevEl: ".prev-slide",
      },
    });

    // instagram slider

    // Initialize Swiper with centered slides
    const swiper = new Swiper("#insta-slider", {
      effect: "coverflow",
      loop: true,
      centeredSlides: true,
      slidesPerView: "auto",
      spaceBetween: 24,
      speed: 1000,
      preloadImages: true,
      // spaceBetween: 100,
      // initialSlide: 2,
      // loopAdditionalSlides: 2,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
        pauseOnMouseEnter: false,
      },
      pagination: {
        el: ".swiper-pagination-custom",
        clickable: true,
        renderBullet: function (index, className) {
          return (
            '<div class="' +
            className +
            ' w-2 h-2 bg-gray-400 rounded-none swiper-pagination-bullet"></div>'
          );
        },
      },

      coverflowEffect: {
        rotate: 0,
        stretch: 80,
        depth: 200,
        modifier: 1,
        slideShadows: false,
      },
      breakpoints: {
        320: {
          slidesPerView: "auto",
        },
      },
      // on: {
      //   init: function () {
      //     updateSlideStyles(this);
      //   },
      //   slideChange: function () {
      //     updateSlideStyles(this);
      //   },
      //   slideChangeTransitionEnd: function () {
      //     updateSlideStyles(this);
      //   },
      //   progress: function () {
      //     updateSlideStyles(this);
      //   },
      // },
    });

    // Update slide styles based on active state
    // function updateSlideStyles(swiperInstance) {
    //   const slides = swiperInstance.slides;

    //   slides.forEach((slide, index) => {
    //     const instagramBtn = slide.querySelector(".instagram-btn");
    //     const imageContainer = slide.querySelector(".image-container");

    //     // Reset all slides to default state - SMALLEST
    //     slide.style.transition = "all 0.6s cubic-bezier(0.4, 0, 0.2, 1)";
    //     slide.style.opacity = "0.5";
    //     slide.style.zIndex = "1";
    //     slide.style.transform = "translateY(0px)";

    //     // Set default smallest size for all slides
    //     if (imageContainer) {
    //       imageContainer.style.width = "250px";
    //       imageContainer.style.height = "200px";
    //       imageContainer.style.borderRadius = "0px";
    //       imageContainer.style.overflow = "hidden";
    //       imageContainer.style.transition =
    //         "all 0.6s cubic-bezier(0.4, 0, 0.2, 1)";
    //       imageContainer.style.boxShadow = "0 4px 12px rgba(0, 0, 0, 0.1)";
    //     }

    //     // Hide instagram buttons on all slides
    //     if (instagramBtn) {
    //       instagramBtn.style.opacity = "0";
    //       instagramBtn.style.visibility = "hidden";
    //       instagramBtn.style.transition = "all 0.3s ease";
    //     }
    //   });

    //   // Get the real active index (accounting for loop)
    //   const realActiveIndex = swiperInstance.realIndex;

    //   // Active (center) slide - LARGEST
    //   const activeSlide = slides[swiperInstance.activeIndex];
    //   if (activeSlide) {
    //     const imageContainer = activeSlide.querySelector(".image-container");

    //     // Make active slide most prominent
    //     activeSlide.style.opacity = "1";
    //     activeSlide.style.zIndex = "10";
    //     activeSlide.style.transform = "translateY(-20px)"; // Slight lift effect

    //     if (imageContainer) {
    //       // Largest size matching your design
    //       imageContainer.style.width = "424px"; // Match your screenshot width
    //       imageContainer.style.height = "424px"; // Match your screenshot height
    //       imageContainer.style.borderRadius = "0px";
    //       imageContainer.style.boxShadow = "0 25px 50px rgba(0, 0, 0, 0.2)";
    //     }

    //     // Show instagram button only on active slide
    //     const activeInstagramBtn = activeSlide.querySelector(".instagram-btn");
    //     if (activeInstagramBtn) {
    //       activeInstagramBtn.style.opacity = "1";
    //       activeInstagramBtn.style.visibility = "visible";
    //     }
    //   }

    //   // Adjacent slides (prev and next) - MEDIUM
    //   const totalSlides = slides.length;
    //   const prevSlideIndex =
    //     swiperInstance.activeIndex === 0
    //       ? totalSlides - 1
    //       : swiperInstance.activeIndex - 1;
    //   const nextSlideIndex =
    //     swiperInstance.activeIndex === totalSlides - 1
    //       ? 0
    //       : swiperInstance.activeIndex + 1;

    //   // Style previous slide (left of center)
    //   if (slides[prevSlideIndex]) {
    //     const slide = slides[prevSlideIndex];
    //     const imageContainer = slide.querySelector(".image-container");

    //     slide.style.opacity = "0.8";
    //     slide.style.zIndex = "5";
    //     slide.style.transform = "translateY(-10px)";

    //     if (imageContainer) {
    //       imageContainer.style.width = "340px"; // Medium size
    //       imageContainer.style.height = "272px"; // Medium size
    //       imageContainer.style.borderRadius = "0px";
    //       imageContainer.style.boxShadow = "0 15px 30px rgba(0, 0, 0, 0.15)";
    //     }
    //   }

    //   // Style next slide (right of center)
    //   if (slides[nextSlideIndex]) {
    //     const slide = slides[nextSlideIndex];
    //     const imageContainer = slide.querySelector(".image-container");

    //     slide.style.opacity = "0.8";
    //     slide.style.zIndex = "5";
    //     slide.style.transform = "translateY(-10px)";

    //     if (imageContainer) {
    //       imageContainer.style.width = "340px"; // Medium size
    //       imageContainer.style.height = "272px"; // Medium size
    //       imageContainer.style.borderRadius = "0px";
    //       imageContainer.style.boxShadow = "0 15px 30px rgba(0, 0, 0, 0.15)";
    //     }
    //   }
    // }
  } else {
    console.warn("Swiper library not loaded.");
  }

  // ===== category Page Price Range Start Here =====
  const priceRange = document.getElementById("priceRange");
  const currentPrice = document.getElementById("currentPrice");

  priceRange.addEventListener("input", () => {
    currentPrice.textContent = `$${priceRange.value}`;
  });
  // ===== category Page Price Range end Here =====
});

// ===== Product Page Counter Script Start Here =====
// const counter = document.getElementById("counter");
// const increment = document.getElementById("increment");
// const decrement = document.getElementById("decrement");
// const priceEl = document.getElementById("price"); // Price element

// const unitPrice = 240.0; // Price per item

// function updatePrice() {
//   const qty = parseInt(counter.textContent);
//   priceEl.textContent = (unitPrice * qty).toFixed(2);
// }

// // Increment quantity
// increment.addEventListener("click", () => {
//   counter.textContent = parseInt(counter.textContent) + 1;
//   updatePrice();
// });

// // Decrement quantity
// decrement.addEventListener("click", () => {
//   let current = parseInt(counter.textContent);
//   if (current > 1) {
//     // prevent quantity below 1
//     counter.textContent = current - 1;
//     updatePrice();
//   }
// });

// // Initialize price on page load
// updatePrice();

// Select main image and all thumbnails
const mainImage = document.querySelector(".product-main-image img"); // Selects the first img with class 'myImageClass'

const thumbnails = document.querySelectorAll(".thumbnail .image img");

console.log(mainImage);
console.log(thumbnails);

// Add click event to each thumbnail and replace main image src on click
thumbnails.forEach((thumbnail) => {
  thumbnail.addEventListener("click", () => {
    const newSrc = thumbnail.src;
    mainImage.src = newSrc;
  });
});

// ===== Product Page Counter Script End Here =====
